import service from '../../utils/request'


const generateOrder = (data) => {
    return service({
        url: 'api/order/generateOrder',
        method: 'post',
        data
   
    })
}
const toPay = (data,pid) => {
    return service({
        url: `api/order/toPay/${pid}`,
        method: 'post',
        data
    })
}
const getOrderByApplyNo = (data) => {
    return service({
        url: `api/order/getOrderByApplyNo`,
        method: 'post',
        data
    })
}

const getOpenid = (data) => {
    return service({
        url: `api/order/obtainOpenid`,
        method: 'post',
        data
    })
}

const getWxConfig = (data) => {
    return service({
        url: `api/getWxConfig`,
        method: 'post',
        data
    })
}


export {
    generateOrder,
    toPay,
    getOrderByApplyNo,
    getWxConfig,
    getOpenid
}